import { createAction, props } from "@ngrx/store";
import { selectedRowData } from "../../shared/types/TableComponentState";
import { LetterOfAuthorizationResponse } from "../../create-request/models/pdf/LetterOfAuthorizationResponse";

export const backButtonClicked = createAction(
    '[Transaction View] Back button clicked'
);

export const backButtonClickedFromMsv = createAction(
    '[Master Status View] Back button clicked'
);

export const editButtonClicked = createAction(
    '[Transaction View] Edit button clicked'
);

export const startTransactionButtonClicked = createAction(
    '[Transaction View] Start transaction button clicked',
    props<{ draftId: string }>()
)

export const resetIsEauthForEditFlow = createAction(
    '[Transaction View] Reset IsEauthForEditFlow property'
);

export const editProfileClicked = createAction(
    '[Standing Authorizations Table] Edit Profile',
    props<{ rowData: selectedRowData }>()
  );

export const generateAuthorizationFormStandingAuth = createAction(
    '[Transaction View] Generate authorization form for pending standing authorization'
);

export const generateAuthorizationFormStandingAuthSuccessful = createAction(
    '[Transaction View]  Generate authorization form for pending standing authorization successful',
    props<{ response: LetterOfAuthorizationResponse }>()
);

export const generateAuthorizationFormStandingAuthFail = createAction(
    '[Transaction View] Error generating authorization form for pending standing authorization',
    props<{ errorMsg: string }>()
);